import React from 'react'
import './HorizontalChart.css'
import { Typography } from '@mui/material'
// import { viewAll } from '../../../assets/icons'
import { useGlobal } from '../../../shared'
import { urls } from '../../../shared/config'
import { useDispatch } from 'react-redux'
import { setRefreshPage } from '../../../redux/globalSlice'

const HorizontalChart = ({ sales, feeData, selectedYear, setSelectedYear }) => {
  const dispatch = useDispatch()
  const userSchoolId = localStorage.getItem('userSchoolId')
  const storedAttributes = localStorage.getItem('userAttributes')
  const attributes = JSON.parse(storedAttributes)
  const customRole = attributes?.employee_type

  const salesData = [
    { label: 'Paid', value: feeData?.paid, color: '#FF7373FA' },
    { label: 'Unpaid', value: feeData?.unPaid, color: '#83FF88CF' },
  ]

  const currentYear = new Date().getFullYear()
  const yearOptions = Array.from({ length: 10 }, (_, index) => {
    const year = (currentYear - index).toString()
    return (
      <option key={year} value={year}>
        {year}
      </option>
    )
  })
  const handleYearChange = (event) => {
    dispatch(setRefreshPage(true))
    setSelectedYear(event.target.value)
  }

  const { data: dataChart } = useGlobal({
    userUrl: `${urls.EXPENSE_CATEGORY_CHART}${selectedYear}&school_id=${customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : ''}`,
  })

  const charHtData = dataChart?.map((entry) => ({
    label: entry.category,
    value: entry.totalSum,
    // color: categoryColors[entry.category] || '#000000',
  }))

  const chartData = sales ? salesData : charHtData
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>
          <Typography fontSize={'14px'} sx={{ color: '#667085' }}>
            Statistics
          </Typography>
          <Typography fontSize={'24px'} fontWeight={900}>
            {sales ? 'Fees' : 'Categories'}
          </Typography>
        </div>
        <select id="select-field" name="year" value={selectedYear} onChange={handleYearChange}>
          {yearOptions}
        </select>
      </div>
      <div className="horizontal-chart">
        {chartData?.map((entry, index) => (
          <div key={index} className="chart-entry">
            <div className="label">
              <Typography fontSize="12px">{entry.label}</Typography>
              <Typography fontSize="12px">₹{entry.value}</Typography>
            </div>
            <div className="bar-container">
              <div
                className="bar"
                style={{ width: `${entry.value / 1000}%`, backgroundColor: '#9291A5' }}
              ></div>
            </div>
          </div>
        ))}
      </div>
      <div className="horizontal-labels">
        <Typography className="h-l-text">0</Typography>
        <Typography className="h-l-text">25k</Typography>
        <Typography className="h-l-text">50k</Typography>
        <Typography className="h-l-text">75k</Typography>
        <Typography className="h-l-text">150k</Typography>
      </div>
      {/* {sales && (
        <Typography className="view-all-txt" mt={2}>
          View All activities <img src={viewAll} />
        </Typography>
      )} */}
    </div>
  )
}

export default HorizontalChart
